import { useState } from 'react';
import { Box, Checkbox, Divider, Typography, Button } from '@mui/material';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  page: {
  background: '#f5f7fa',  
  padding: '40px 20px',
  minHeight: '90vh', 
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  fontFamily: 'Rubik, sans-serif',
},
  descrippt: {
    fontFamily: 'Rubik, sans-serif',
    fontSize: 21,
    fontWeight: 500,
    marginTop: '15px',
    marginBottom: '10px',
    textAlign: 'center'
  },
  descripptTxt: {
    fontFamily: 'Rubik, sans-serif',
    fontSize: 16,
    fontWeight: 500,
        textAlign: 'center'

  },
  finalCount: {
    fontFamily: 'Rubik, sans-serif',
    fontSize: 16,
    fontWeight: 500,
    marginBottom: '20px',
  },
card: {
  background: '#fff',
  borderRadius: 20,  
  padding: '62px 20px',
  maxWidth: 450,
  width: '100%',
  boxShadow: '0 12px 36px rgba(0, 0, 0, 0.06)',  
  fontFamily: 'Rubik, sans-serif',
},

  section: {
    marginBottom: 24,
  },
  groupTitle: {
    fontWeight: 500,
    fontFamily: 'Rubik, sans-serif',
  },
  itemRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  itemLabel: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
    fontFamily: 'Rubik, sans-serif',
    flex: 1,
  },
  labelPurple: {
    color: '#4551D1',
    fontSize: 14,
    fontWeight: 500,
  },
  labelText: {
    display: 'flex',
    flexDirection: 'column',
    fontFamily: 'Rubik, sans-serif',
    gap: 8,
    marginTop: '10px',
  },

  description: {
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Rubik, sans-serif',
  },
  amount: {
    fontWeight: 500,
    fontSize: 14,
    whiteSpace: 'nowrap',
    fontFamily: 'Rubik, sans-serif',
  },
  itemBox: {
    border: '1px solid #5664F5',
    borderRadius: '10px',
    padding: '6px 12px 3px 12px',
    marginBottom: '12px',
  },

  button: {
    backgroundColor: '#5664F5',
    height: '40px',
    fontSize: 14,
    fontWeight: 600,
    borderRadius: '10px',
    marginTop: '20px',
    padding: '0 60px',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#4352d6',
    },
  },
  labelContent: {
    display: 'flex',
    justifyContent: 'space-between',
    flex: 1,
    alignItems: 'center',
  },
}));

export default function SuccesssPage() {
  const classes = useStyles();
  let success = '../../../../success.png';

  return (
    <div className={classes.page}>
      <div className={classes.card}>

        <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
        <img style={{ width: '60px' }} src={success} alt="success" />

          <div className={classes.descrippt}>Успешно</div>

          <div className={classes.descripptTxt}>1 000 ₽</div>

          <Button variant="contained" className={classes.button}>
            Закрыть
          </Button>
        </div>
      </div>
    </div>
  );
}
